'use strict';
/*
* Use this file to call functions in other files, on document ready, window.resize etc.
*/

var twentyninetimes = twentyninetimes || {};

// Document ready
document.addEventListener('DOMContentLoaded', function(){

    twentyninetimes.siteHeader.init();
    twentyninetimes.navigation.init();
    twentyninetimes.loadMore.init();
    twentyninetimes.oembedToggle.init();
    twentyninetimes.siteSliders.init();
    twentyninetimes.faqs.init();
    twentyninetimes.accordion.init();
    twentyninetimes.formular.init();
    twentyninetimes.siteHeader.checkLogoPlacement();
    twentyninetimes.maskCorner.init();

    var inViewItems = document.querySelectorAll('.in-view-item, .wp-site-blocks > *:not(.block-hero):not(.wp-block-spacer):not(.wp-block-group.alignfull.has-background):not(.block-loop-employee):not(.block-loop-treatment):not(.block-loop-post), .wp-block-group.alignfull.has-background > *:not(.wp-block-spacer):not(.block-loop-employee):not(.block-loop-treatment):not(.block-loop-post)');
    if ( inViewItems ) {
        var test = (item) => {
            if ( !item.classList.contains('visible') ) {
                item.classList.add('visible');
            }
        };
        twentyninetimes.inView.init(inViewItems, test, -100);
    }

    // Scroll functions
    window.onscroll = function () {
        // INSERT FUNCTIONS TO TRIGGER ON SCROLL

        twentyninetimes.siteHeader.checkScroll();
        twentyninetimes.siteHeader.checkLogoPlacement();
    };

    // Resize functions
    window.onresize = function () { 
        // INSERT FUNCTIONS TO TRIGGER ON WINDOW RESIZE
    };
    
});


